import { all, fork } from 'redux-saga/effects';

import referenceRateSaga from './referenceRate';

export default function* rootSaga() {
  yield all([
    fork(referenceRateSaga),
  ]);
}
